import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';

export class UpdateOrderDeliveryFeeDto {
  @IsString()
  @IsOptional()
  @Expose()
  deliveryFee?: string;
}
